import { getCookie } from 'bv';

export default () => (
  parseInt(getCookie('price_format_id'), 10) || 2
);
